export const groupPendingExtrasMessages = {
  "Add extras to the group": "Añadir extras al grupo",
  "Existing extras and consumed nights will not be changed.": "No se modificarán los extras existentes ni las noches consumidas.",
  "Group #{id}": "Grupo n.º {id}",
  "1. Choose extras": "1. Elige los extras",
  "Choose an extra…": "Elige un extra…",
  "2. Choose reservations and pending nights": "2. Elige reservas y noches pendientes",
  "3. Review the additional charge": "3. Revisa el importe que se añadirá",
  "Per night": "Por noche",
  "Once per stay": "Una vez por estancia",
  "Reservation #{id}": "Reserva n.º {id}",
  "Remove {name}": "Quitar {name}",
  "Select {name} for {reservation}": "Seleccionar {name} para {reservation}",
  "{count} pending nights": "{count} noches pendientes",
  "{count} consumed or unavailable nights": "{count} noches consumidas o no disponibles",
  "{count} nights already have this extra": "Este extra ya está aplicado en {count} noches",
  "Up to {count} additional nights": "Hasta {count} noches adicionales",
  "Select available nights": "Seleccionar noches disponibles",
  "Clear nights": "Desmarcar noches",
  "Service date": "Fecha del servicio",
  "Choose a date…": "Elige una fecha…",
  "No pending nights available.": "No hay noches pendientes disponibles.",
  "Not eligible for this extra.": "No admite este extra.",
  "This extra is already applied.": "Este extra ya está aplicado.",
  "No extras available for this group.": "No hay extras disponibles para este grupo.",
  "No eligible reservations in this group.": "No hay reservas del grupo que admitan nuevos extras.",
  "Select an extra and at least one eligible reservation/date.": "Elige un extra y al menos una reserva y fecha disponibles.",
  "The server calculates the exact amount, including eligibility and currency conversion.": "El servidor calcula el importe exacto, incluidos los requisitos y la conversión de moneda.",
  "Fixed group extras are shared across the selected reservations; they are not multiplied by the room count.": "Los extras de grupo de importe fijo se reparten entre las reservas seleccionadas; no se multiplican por el número de habitaciones.",
  "Extra": "Extra",
  "Dates": "Fechas",
  "Amount": "Importe",
  "Additional total": "Total que se añadirá",
  "{count} reservations": "{count} reservas",
  "Add selected extras": "Añadir extras seleccionados",
  "Adding extras…": "Añadiendo extras…",
  "Loading eligible extras…": "Cargando extras disponibles…",
  "Calculating additional charge…": "Calculando el importe adicional…",
  "The group or hotel is not valid.": "El grupo o el hotel no son válidos.",
  "Unable to load eligible extras.": "No se pudieron cargar los extras disponibles.",
  "The extras response does not match this group and hotel.": "La respuesta de extras no corresponde a este grupo y hotel.",
  "Unable to calculate the additional charge. Change the selection or retry.": "No se pudo calcular el importe adicional. Cambia la selección o vuelve a intentarlo.",
  "The price preview is incomplete. Nothing has been saved.": "La vista previa del precio está incompleta. No se ha guardado nada.",
  "Availability or prices changed. Review the updated options before confirming again.": "Han cambiado la disponibilidad o los precios. Revisa las opciones actualizadas antes de confirmar de nuevo.",
  "The operation could not be confirmed. Retry the same operation to check its result without adding duplicates.": "No se pudo confirmar el resultado. Reintenta la misma operación para comprobarlo sin añadir duplicados.",
  "Retry safely": "Reintentar sin duplicar",
  "Operation awaiting confirmation": "Operación pendiente de confirmar",
  "Retry loading": "Reintentar carga",
  "Retry calculation": "Reintentar cálculo",
  "The operation was rejected. No extras were added.": "La operación ha sido rechazada. No se ha añadido ningún extra.",
  "A secure operation identifier could not be created.": "No se pudo crear un identificador seguro para la operación.",
  "Extras added successfully.": "Extras añadidos correctamente.",
  "Extras were added, but the reservation view could not be refreshed. Close and reopen the group.": "Los extras se han añadido, pero no se pudo actualizar la vista de la reserva. Cierra y vuelve a abrir el grupo.",
  "Close extras dialog": "Cerrar el cuadro de extras",
};
